//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uParse from '@/components/gaoyia-parse/parse.vue'
export default{
	props: {
		detail: { //详情的内容
			type: Object,
			default: {}
		},
		scenicspotIds:{ //景区列表
			type:Array,
			default:[]
		},
		state:{ //当前对应的攻略栏目（类型 字符串）1官方推荐 2官方游记 3游客分享
			type:String
		}
	},
	components: {uParse},
	computed: {
		// 日程
		days () {
			if (parseFloat(this.detail.severalDays) === 0.5) {
				return '半'
			} else {
				return this.schedule[(this.detail.severalDays - 1)]
			}
		},
		//游客分享照片集数组
		mainBody(){
			return this.detail.mainBody ? JSON.parse(this.detail.mainBody) : []
		}
	},
	data() {
		return {
			schedule:['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二', '十三', '十四', '十五'],
		}
	},
	methods: {
	},
}
